export default __webpack_public_path__ + "static/media/default.616124f9.png";